import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import ClientService from './../../../clientmanagement/services/clientmanagement.service';
import Report from './../../../report/services/report.service';
import Papa from "papaparse";
import XLSX from 'xlsx';
import Multiselect from 'vue-multiselect'

export default {
  name: 'clientlevelreport',
  components: {
    ClientService,
    Treeselect,
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
     Clientlist:[],
     client :null,
     ClientID:"",
     RouteModelist:[
       {id:'Surface',label:'Surface'},
       {id:'Air',label:'Air'},
     ],
     clientcommersialArray:[],
      TruckLoadType: 'PTL',
     routeModeSearch:null,
     truckLoadTypeSearch:null,
     isLoading:false
    }
  },
  computed: {
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getCompanyShortName();
  },
  methods: {
    async downloadSalesTAT(salesdata, clientid, clientname, routemode){
      let tempData = [];
      salesdata.forEach((item)=>{
        tempData.push({
          "Origin Region":item.originregion,
          "Origin State":item.originstate,
          "Origin City":item.origincity,
          "Destination Region":item.destinationregion,
          "Destination State":item.destinationstate,
          "Destination City":item.destinationcity,
          "Route Mode" :item.travelmode,
          "E2E TAT":parseInt(item.tat)
        });
      });
      var blob = new Blob([Papa.unparse(tempData)], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      let filename = clientname+'_'+routemode+'_Sales TAT.csv';
      link.setAttribute("download", filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async downloadRateTAT(ratedata, clientid, clientname, routemode){
      let tempData = [];
      let slabtype = 'Flat';
      if(ratedata[0].slabtype){
         slabtype = 'Slab';
      }

      ratedata.forEach((item)=>{
        let tempObj = {
          "Origin Region":item.originregion,
          "Origin State":item.originstate,
          "Origin City":item.origincity,
          "Origin Territory":item.originterritory,
          "Destination Region":item.destinationregion,
          "Destination State":item.destinationstate,
          "Destination City":item.destinationcity,
          "Destination Territory":item.destinationterritory,
          "Route Mode" :item.travelmode,
          "Rate Basis":(item.ratebasis == 1)?"Weight":(item.ratebasis == 2)?"Quantity":"",
          "Rate Type" :slabtype,
        }
        if (slabtype=="Slab") {
          tempObj['Slab Type'] = (item.slabtype == 1)?"Weight":(item.slabtype == 2)?"Quantity":"";
          for (let index = 0; index < item.ratetat.length; index++) {
            let splitFunction = item.ratetat[index].split("=");
            let slabbreak = index+1;
            tempObj['Slab Break ' + slabbreak + ' (Low - High)'] = splitFunction[0];
            tempObj['Slab Break ' + slabbreak + ' Rate per basis (INR)'] = splitFunction[1];
          }
        }else{
          tempObj['Rate per basis (INR)'] = item.ratetat;
        }
        tempData.push(tempObj);
      });
      var blob = new Blob([Papa.unparse(tempData)], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      let filename = clientname+'_'+routemode+'_Rate TAT.csv';
      link.setAttribute("download", filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async downloadClientLevelReport(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "clientid": this.client.id,
          "clientbussinessaccountid": this.client.ClientBusinessAccountId,
          "routemode": this.routeModeSearch,
          "truckloadtype": this.TruckLoadType
        }
        let result = await Report.downloadClientTatReport(inputPayload);
        this.isLoading = false;
        if (result.data.code == 409) {
          this.$alert(result.data.message, "Download Rate & Sales TAT", "error");
          return false;
        }else{
          if (result.data.data.servicelevel && result.data.data.servicelevel.length > 0) {
            let salesdata = result.data.data.servicelevel;
            await this.downloadSalesTAT(salesdata, this.client.id, this.client.label, this.routeModeSearch);
          } else {
            this.$alertify.error("Sales TAT Data Not Found");
          }
          if (result.data.data.baserate && result.data.data.baserate.length > 0) {
            let ratesdata = result.data.data.baserate;
            await this.downloadRateTAT(ratesdata, this.client.id, this.client.label, this.routeModeSearch);
         } else {
           this.$alertify.error("Rate TAT Data Not Found");
         }
       }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async downloadClientCommersialsDetails(){
      try {
        this.isLoading = true;
        let payload = {};
        let result = await Report.getClientCommersialsDetailsforDownload(payload)
        this.isLoading = false
          if (result.data.code == 200) {
             let maxcount = result.data.data.maxslabcounts;
             let tempData = result.data.data.contractdata.map((el)=>{
               let tempObj = {};
               tempObj['Client Name'] = el.clientcompanyname;
               tempObj['Client System ID'] = el.clientid;
               tempObj['Client Business Account ID'] = el.clientbusinessaccountid;
               tempObj['Route Mode'] = el.routemode;
               tempObj['Rate Basis'] = el.ratebasis;
               tempObj['UOM'] = el.uom;
               tempObj['CFT'] = el.agreedwtcft;

               let applicablewt;
               let applicableMaxMinList = [{text:"Min", value:"min"},{text:"Max", value:"max"}];
               let ApplicableWeightList = [{text:"Physical Weight", value:"physicalweight"},
               {text:"Volumetric Weight", value:"volumetricweight"},
               {text:"Max (Physical Weight or Volumetric Weight)", value:"maxofphysicalorvolumetricweight"}];

               let ApplicableWeightList2 = [{text:"Physical Weight", value:"physicalweight"},
               {text:"Volumetric Weight", value:"volumetricweight"},
               {text:"Minimum Chargeable Weight", value:"chargeableweight"}];

               if(el.applicablewt && el.ratebasis=="Weight"){
                 let applicableMinMax = el.applicablewt && el.applicablewt.maxMin && applicableMaxMinList.find(o => o.value == el.applicablewt.maxMin).text;
                 let applicableWeight1 = el.applicablewt && el.applicablewt.weight1 && ApplicableWeightList.find(o => o.value == ( el.applicablewt.weight1)).text;
                 let applicableWeight2 = el.applicablewt && el.applicablewt.weight2 && ApplicableWeightList2.find(o => o.value == (el.applicablewt.weight2)).text;
                 applicablewt = applicableMinMax +' OF ('+applicableWeight1+' OR '+applicableWeight2+'))';
               }

               tempObj['Applicable Weight'] = applicablewt;
               tempObj['Minimum Chargeable Weight/Minimum Boxes'] = el.minimumchargeablewt;
               tempObj['Tariff Type'] = el.tarifftype;
               tempObj['Minimum Charges per Docket Basis'] = el.minimumchargetype;
               tempObj['Minimum Charges per Docket'] = el.minimumcharges;
               tempObj['Insurance Charges Type'] = el.insuranceapplicablecharge;
               tempObj['Charge Type'] = el.insurancechargetype;
               tempObj['FOV % Type'] = el.fovtype;

               let fovslabarray = el.fovvalue;
               let fovminvalue;
               let fovmaxvalue;
               if(el.fovtype && el.fovvalue && fovslabarray.length > 0){
                 fovminvalue = fovslabarray[0].minfovvalue;
                 fovmaxvalue = fovslabarray[0].maxfovvalue;
               }

               if(el.fovtype && el.insurancechargetype=="Flat Charges per Shipment"){
                 tempObj['If Flat Rate, FOV Charge Per Shipment (INR)'] = fovslabarray[0].fovvalue;
               }else{
                 tempObj['If Flat Rate, FOV Charge Per Shipment (INR)'] = "";
               }

               if(el.fovtype && el.fovtype=="Flat Rate" && el.fovvalue){
                 tempObj['FOV/ROV Rate (%)'] = fovslabarray[0].fovvalue;
               }else{
                 tempObj['FOV/ROV Rate (%)'] = "";
               }

               let maxinsuranceslab = maxcount.maxinsuranceslab;
               for(var i=0; i < maxinsuranceslab; i++){
                 let fovslabkey = 'If Slab Based, FOV/ROV Slab Break '+ parseInt(i+1);
                 let fovslabvaluekey = 'Slab '+parseInt(i+1)+' FOV/ROV %';
                 if(el.fovtype && fovslabarray[i] && el.fovtype=="Slab Based"){
                   tempObj[fovslabkey] = fovslabarray[i].fromvalue +'-'+ fovslabarray[i].tovalue;
                   tempObj[fovslabvaluekey] = fovslabarray[i].fovvalue;
                 }else{
                   tempObj[fovslabkey] = "";
                   tempObj[fovslabvaluekey] = "";
                 }
               }
               tempObj['FOV/ROV Min Limit'] = fovminvalue;
               tempObj['FOV/ROV Max Limit'] = fovmaxvalue;
               tempObj['Waybill Charges'] = el.waybillcharge;
               tempObj['DC Charges'] = el.dccharges;
               tempObj['FTC/To Pay Charges Basis'] = el.fodchargetype;
               tempObj['Per docket Charges'] = (el.fodchargetype=="Per Docket"?el.fodcharges:"");
               tempObj['% of Freight Charges'] = (el.fodchargetype=="% of Freight Charges"?el.fodcharges:"");
               tempObj['FTC Charges Limit (Min)'] = el.fodmincharge;
               tempObj['FTC Charges Limit (Max)'] = el.fodmaxcharge;
               tempObj['Fuel Surcharge %'] = el.fuelsurchargepercent;
               tempObj['Diesel Price (INR/Ltr) on Agreement Date'] = el.fueldieselrate;
               tempObj['Diesel Price Hike By (INR/%)'] = (el.dieselhiketype)?el.dieselhiketype:'%';
               tempObj['Location Basis for Reference Diesel Price'] = el.dieselreflocation;
               tempObj['Increase in Fuel Rate By'] = el.fueluprevision;
               tempObj['Increase in Base Rate By'] = el.fueluprevisioncharge;
               tempObj['Decrease in Fuel Rate By'] = el.fueldownrevision;
               tempObj['Decrease in Base Rate By'] = el.fueldownrevisioncharge;
               tempObj['Free Delivery Attempts'] = el.deliveryattempt;
               tempObj['Minimum cost per paid attempt per docket (INR)'] = el.deliveryattemptmincharge;
               tempObj['Cost per paid attempt per kg'] = el.costperdeliveryattemptperkg;
               tempObj['Cost per paid attempt per box'] = el.costperdeliveryattemptperbox;
               tempObj['Storage Charges'] = el.demurragechargesapplicable;
               tempObj['Free Storage Days'] = el.demurragefreestoragedays;
               tempObj['Cost per kg per day (INR)'] = el.demurragecostperdayperkg;
               tempObj['Cost per box per day (INR)'] = el.demurragecostperdayperbox;
               tempObj['Slot days'] = el.demurrageslotsdays;
               tempObj['Cost per slot days (INR)'] = el.demurragecostperslotsdays;
               tempObj['Cost per Docket per Day (INR)'] = el.demurrageminimumcharges;
               tempObj['Appointment/Different Vehicle Delivery'] = el.vehicledeliveryapplicable;
               tempObj['Appointment/Different Vehicle Delivery Rate Basis'] = el.vehicledeliveryratebasis;
               tempObj['Type of Charge'] = el.vehicledeliverychargetype;

               let vehiclecostperkg = "";
               let vehiclecostperbox = "";
               if(el.vehiclecost && el.vehicledeliverychargetype=="Flat Rate"){
                 if(el.vehicledeliveryratebasis=="Weight (kg)"){
                   vehiclecostperkg = el.vehiclecost[0].cost;
                 }else{
                   vehiclecostperbox = el.vehiclecost[0].cost;
                 }
               }

               tempObj['For Flat Rate, Cost per kg (INR)'] = vehiclecostperkg;
               tempObj['For Flat Rate, Cost per box (INR)'] = vehiclecostperbox;
               tempObj['Minimum Charge per Docket'] = el.vehicledeliveryminimumchargeperdocket;
               tempObj['Slab Type'] = el.vehicledeliveryslabtype;
               tempObj['Slab Charge Type'] = el.vehicledeliveryslabchargetype;

               let maxvehicleslab = maxcount.maxvehicleslab;
               let vehicleslabarray = el.vehiclecost;
               for(var i=0; i < maxvehicleslab; i++){
                 let vehicleslabkey = 'Slab Break '+ parseInt(i+1);
                 let vehicleslabvaluekey = 'Slab '+parseInt(i+1)+', Cost per Docket';
                 if(el.vehiclecost && vehicleslabarray[i] && el.vehicledeliverychargetype=="Slab Based"){
                   tempObj[vehicleslabkey] = vehicleslabarray[i].fromvalue +'-'+ vehicleslabarray[i].tovalue;
                   tempObj[vehicleslabvaluekey] = vehicleslabarray[i].cost;
                 }else{
                   tempObj[vehicleslabkey] = "";
                   tempObj[vehicleslabvaluekey] = "";
                 }
               }

               tempObj['Mathadi/ Varai Charges, Flat rate per box (MPS) (INR)'] = el.mathadichargesperbox;
               tempObj['Handling Charges'] = el.handlingchargesapplicable;
               tempObj['Max Limits for no Handling Charges, Physical Weight (kg)'] = el.handlingchargephysicalwt;
               let handlingdimensions = "";
               if(el.handlingchargedimesnion && el.handlingchargesapplicable=="Yes"){
                 handlingdimensions = el.handlingchargedimesnion.handlinglength+'x'+el.handlingchargedimesnion.handlingbreadth+"x"+el.handlingchargedimesnion.handlingHeight;
               }
               tempObj['Dimensions (cm), LxBxH'] = handlingdimensions;
               tempObj['Over Weight Charges type'] = el.handlingchargeoverwtchargetype;
               let flatoverwtcharge = "";
               if(el.handlingcost && el.handlingchargeoverwtchargetype=="Flat Rate"){
                 flatoverwtcharge = el.handlingcost[0].cost;
               }
               tempObj['For Flat Over Weight charges, Per kg over max Limit charges'] = flatoverwtcharge;

               let maxoverwtchargeslab = maxcount.maxoverwtchargeslab;
               let overwtslabarray = el.handlingcost;
               for(var i=0; i < maxoverwtchargeslab; i++){
                 let overwtslabkey = 'Over Weight Charges, Slab Break '+ parseInt(i+1);
                 let overwtslabvaluekey = 'Slab '+parseInt(i+1)+', Cost per kg (per overweight MPS)';
                 if(el.handlingcost && overwtslabarray[i] && el.handlingchargeoverwtchargetype=="Slab Type"){
                   tempObj[overwtslabkey] = overwtslabarray[i].fromvalue +'-'+ overwtslabarray[i].tovalue;
                   tempObj[overwtslabvaluekey] = overwtslabarray[i].cost;
                 }else{
                   tempObj[overwtslabkey] = "";
                   tempObj[overwtslabvaluekey] = "";
                 }
               }

               tempObj['Mechanical handling charges (forklift/crane) on actuals for weight above (kg)'] = el.mechanicalhandlingcharges;
               tempObj['Delivery Above Ground Level'] = el.delievryabovegroundlevelapplicable;
               tempObj['Max level above ground for no extra charge'] = el.delievryabovegroundlevelmax;
               tempObj['Extra charges for delivery above max level defined, INR per kg per Floor'] = el.delievryabovegroundlevelchargeperkg;
               tempObj['Extra charges for delivery above max level defined, INR per box per Floor'] = el.delievryabovegroundlevelchargeperbox;
               tempObj['Green Tax Charges(Cost per kg)'] = el.greentaxperkg;
               tempObj['Green Tax Charges(Cost per Docket)'] = el.greentaxperdocket;
               tempObj['RTO Charges'] = el.rtocharges;

               tempObj['Pickup ODA Charges'] = el.pickupodachargesapplicable;
               tempObj['Pickup ODA Rate Basis'] = el.pickupodachargeratebasis;
               tempObj['Pickup ODA Rate Type'] = el.pickupodachargetype;
               tempObj['Pickup ODA Minimum Cost per Docket'] = el.pickupodachargesminimum;

               let maxodachargeslab = maxcount.maxodachargeslab;
               let pickupoda1charge = "";
               let pickupoda2charge = "";
               let pickupoda3charge = "";
               let pickupoda4charge = "";
               let pickupoda1chargeperdocket = "" ;
               let pickupoda2chargeperdocket = "" ;
               let pickupoda3chargeperdocket = "" ;
               let pickupoda4chargeperdocket = "" ;
               if(el.pickupodachargetype=="Flat Rate"){
                 if(el.pickupodacharges1){
                   pickupoda1charge = el.pickupodacharges1[0].charges;
                   pickupoda1chargeperdocket = el.pickupodacharges1[0].chargesperdocket;
                 }
                 if(el.pickupodacharges2){
                   pickupoda2charge = el.pickupodacharges2[0].charges;
                   pickupoda2chargeperdocket = el.pickupodacharges2[0].chargesperdocket;
                 }
                 if(el.pickupodacharges3){
                   pickupoda3charge = el.pickupodacharges3[0].charges;
                   pickupoda3chargeperdocket = el.pickupodacharges3[0].chargesperdocket;
                 }
                 if(el.pickupodacharges4){
                   pickupoda4charge = el.pickupodacharges4[0].charges;
                   pickupoda4chargeperdocket = el.pickupodacharges4[0].chargesperdocket;
                 }
               }
               tempObj['Pickup If Flat Rate, ODA 1 Charges, Additional Rate per Kg'] = pickupoda1charge;
               tempObj['Pickup If Flat Rate, ODA 1 Charges, Additional Rate per Docket'] = pickupoda1chargeperdocket;
               tempObj['Pickup If Flat Rate, ODA 2 Charges, Additional Rate per Kg'] = pickupoda2charge;
               tempObj['Pickup If Flat Rate, ODA 2 Charges, Additional Rate per Docket'] = pickupoda2chargeperdocket;
               tempObj['Pickup If Flat Rate, ODA 3 Charges, Additional Rate per Kg'] = pickupoda3charge;
               tempObj['Pickup If Flat Rate, ODA 3 Charges, Additional Rate per Docket'] = pickupoda3chargeperdocket;
               tempObj['Pickup If Flat Rate, Special Pin code Charges, Additional Rate per Kg'] = pickupoda4charge;
               tempObj['Pickup If Flat Rate, Special Pin code Charges, Additional Rate per Docket'] = pickupoda4chargeperdocket;
               tempObj['Pickup If Slab Based, Slab Type'] = el.pickupodachargeslabtype;
               tempObj['Pickup ODA Slab Charge Type'] = el.pickupodachargeslabchargetype;

               let pickupoda1slabarray = el.pickupodacharges1;
               for(var i=0; i < maxodachargeslab; i++){
                 let pickupoda1slabkey = 'Pickup ODA 1 Charges, Slab Break '+ parseInt(i+1);
                 let pickupoda1slabvaluekey = 'Pickup ODA 1 Charges, Slab '+parseInt(i+1)+' Rate';
                 if(el.pickupodacharges1 && pickupoda1slabarray[i] && el.pickupodachargetype=="Slab Rate"){
                   tempObj[pickupoda1slabkey] = pickupoda1slabarray[i].lowerlimitvalue +'-'+ pickupoda1slabarray[i].higherlimitvalue;
                   tempObj[pickupoda1slabvaluekey] = pickupoda1slabarray[i].charges;
                 }else{
                   tempObj[pickupoda1slabkey] = "";
                   tempObj[pickupoda1slabvaluekey] = "";
                 }
               }

               let pickupoda2slabarray = el.pickupodacharges2;
               for(var i=0; i < maxodachargeslab; i++){
                 let pickupoda2slabkey = 'Pickup ODA 2 Charges, Slab Break '+ parseInt(i+1);
                 let pickupoda2slabvaluekey = 'Pickup ODA 2 Charges, Slab '+parseInt(i+1)+' Rate';
                 if(el.pickupodacharges2 && pickupoda2slabarray[i] && el.pickupodachargetype=="Slab Rate"){
                   tempObj[pickupoda2slabkey] = pickupoda2slabarray[i].lowerlimitvalue +'-'+ pickupoda2slabarray[i].higherlimitvalue;
                   tempObj[pickupoda2slabvaluekey] = pickupoda2slabarray[i].charges;
                 }else{
                   tempObj[pickupoda2slabkey] = "";
                   tempObj[pickupoda2slabvaluekey] = "";
                 }
               }

               let pickupoda3slabarray = el.pickupodacharges3;
               for(var i=0; i < maxodachargeslab; i++){
                 let pickupoda3slabkey = 'Pickup ODA 3 Charges, Slab Break '+ parseInt(i+1);
                 let pickupoda3slabvaluekey = 'Pickup ODA 3 Charges, Slab '+parseInt(i+1)+' Rate';
                 if(el.pickupodacharges3 && pickupoda3slabarray[i] && el.pickupodachargetype=="Slab Rate"){
                   tempObj[pickupoda3slabkey] = pickupoda3slabarray[i].lowerlimitvalue +'-'+ pickupoda3slabarray[i].higherlimitvalue;
                   tempObj[pickupoda3slabvaluekey] = pickupoda3slabarray[i].charges;
                 }else{
                   tempObj[pickupoda3slabkey] = "";
                   tempObj[pickupoda3slabvaluekey] = "";
                 }
               }

               let pickupoda4slabarray = el.pickupodacharges4;
               for(var i=0; i < maxodachargeslab; i++){
                 let pickupoda4slabkey = 'Pickup Special Pincode Charges, Slab Break '+ parseInt(i+1);
                 let pickupoda4slabvaluekey = 'Pickup Special Pincode Charges, Slab '+parseInt(i+1)+' Rate';
                 if(el.pickupodacharges4 && pickupoda4slabarray[i] && el.pickupodachargetype=="Slab Rate"){
                   tempObj[pickupoda4slabkey] = pickupoda4slabarray[i].lowerlimitvalue +'-'+ pickupoda4slabarray[i].higherlimitvalue;
                   tempObj[pickupoda4slabvaluekey] = pickupoda4slabarray[i].charges;
                 }else{
                   tempObj[pickupoda4slabkey] = "";
                   tempObj[pickupoda4slabvaluekey] = "";
                 }
               }
               tempObj['Pickup ODA Charges'] = el.pickupodachargesapplicable;
               tempObj['Pickup ODA Rate Basis'] = el.pickupodachargeratebasis;
               tempObj['Pickup ODA Rate Type'] = el.pickupodachargetype;
               tempObj['Pickup ODA Minimum Cost per Docket'] = el.pickupodachargesminimum;

               let oda1charge = "";
               let oda2charge = "";
               let oda3charge = "";
               let oda4charge = "";
               let oda1chargeperdocket = "" ;
               let oda2chargeperdocket = "" ;
               let oda3chargeperdocket = "" ;
               let oda4chargeperdocket = "" ;
               if(el.odachargetype=="Flat Rate"){
                 if(el.odacharges1){
                   oda1charge = el.odacharges1[0].charges;
                   oda1chargeperdocket = el.odacharges1[0].chargesperdocket;
                 }
                 if(el.odacharges2){
                   oda2charge = el.odacharges2[0].charges;
                   oda2chargeperdocket = el.odacharges2[0].chargesperdocket;
                 }
                 if(el.odacharges3){
                   oda3charge = el.odacharges3[0].charges;
                   oda3chargeperdocket = el.odacharges3[0].chargesperdocket;
                 }
                 if(el.odacharges4){
                   oda4charge = el.odacharges4[0].charges;
                   oda4chargeperdocket = el.odacharges4[0].chargesperdocket;
                 }
               }
               tempObj['Delivery If Flat Rate, ODA 1 Charges, Additional Rate per Kg'] = oda1charge;
               tempObj['Delivery If Flat Rate, ODA 1 Charges, Additional Rate per Docket'] = oda1chargeperdocket;
               tempObj['Delivery If Flat Rate, ODA 2 Charges, Additional Rate per Kg'] = oda2charge;
               tempObj['Delivery If Flat Rate, ODA 2 Charges, Additional Rate per Docket'] = oda2chargeperdocket;
               tempObj['Delivery If Flat Rate, ODA 3 Charges, Additional Rate per Kg'] = oda3charge;
               tempObj['Delivery If Flat Rate, ODA 3 Charges, Additional Rate per Docket'] = oda3chargeperdocket;
               tempObj['Delivery If Flat Rate, Special Pin code Charges, Additional Rate per Kg'] = oda4charge;
               tempObj['Delivery If Flat Rate, Special Pin code Charges, Additional Rate per Docket'] = oda4chargeperdocket;
               tempObj['Delivery If Slab Based, Slab Type'] = el.odachargeslabtype;
               tempObj['Delivery ODA Slab Charge Type'] = el.odachargeslabchargetype;

               let oda1slabarray = el.odacharges1;
               for(var i=0; i < maxodachargeslab; i++){
                 let oda1slabkey = 'Delivery ODA 1 Charges, Slab Break '+ parseInt(i+1);
                 let oda1slabvaluekey = 'Delivery ODA 1 Charges, Slab '+parseInt(i+1)+' Rate';
                 if(el.odacharges1 && oda1slabarray[i] && el.odachargetype=="Slab Rate"){
                   tempObj[oda1slabkey] = oda1slabarray[i].lowerlimitvalue +'-'+ oda1slabarray[i].higherlimitvalue;
                   tempObj[oda1slabvaluekey] = oda1slabarray[i].charges;
                 }else{
                   tempObj[oda1slabkey] = "";
                   tempObj[oda1slabvaluekey] = "";
                 }
               }

               let oda2slabarray = el.odacharges2;
               for(var i=0; i < maxodachargeslab; i++){
                 let oda2slabkey = 'Delivery ODA 2 Charges, Slab Break '+ parseInt(i+1);
                 let oda2slabvaluekey = 'Delivery ODA 2 Charges, Slab '+parseInt(i+1)+' Rate';
                 if(el.odacharges2 && oda2slabarray[i] && el.odachargetype=="Slab Rate"){
                   tempObj[oda2slabkey] = oda2slabarray[i].lowerlimitvalue +'-'+ oda2slabarray[i].higherlimitvalue;
                   tempObj[oda2slabvaluekey] = oda2slabarray[i].charges;
                 }else{
                   tempObj[oda2slabkey] = "";
                   tempObj[oda2slabvaluekey] = "";
                 }
               }

               let oda3slabarray = el.odacharges3;
               for(var i=0; i < maxodachargeslab; i++){
                 let oda3slabkey = 'Delivery ODA 3 Charges, Slab Break '+ parseInt(i+1);
                 let oda3slabvaluekey = 'Delivery ODA 3 Charges, Slab '+parseInt(i+1)+' Rate';
                 if(el.odacharges3 && oda3slabarray[i] && el.odachargetype=="Slab Rate"){
                   tempObj[oda3slabkey] = oda3slabarray[i].lowerlimitvalue +'-'+ oda3slabarray[i].higherlimitvalue;
                   tempObj[oda3slabvaluekey] = oda3slabarray[i].charges;
                 }else{
                   tempObj[oda3slabkey] = "";
                   tempObj[oda3slabvaluekey] = "";
                 }
               }

               let oda4slabarray = el.odacharges4;
               for(var i=0; i < maxodachargeslab; i++){
                 let oda4slabkey = 'Delivery Special Pincode Charges, Slab Break '+ parseInt(i+1);
                 let oda4slabvaluekey = 'Delivery Special Pincode Charges, Slab '+parseInt(i+1)+' Rate';
                 if(el.odacharges4 && oda4slabarray[i] && el.odachargetype=="Slab Rate"){
                   tempObj[oda4slabkey] = oda4slabarray[i].lowerlimitvalue +'-'+ oda4slabarray[i].higherlimitvalue;
                   tempObj[oda4slabvaluekey] = oda4slabarray[i].charges;
                 }else{
                   tempObj[oda4slabkey] = "";
                   tempObj[oda4slabvaluekey] = "";
                 }
               }


               tempObj['Open Pickup and Delivery, Applicable?'] = el.openpickdeliveryapplicable;
               tempObj['Rate per Box per Docket (INR)'] = el.openpickdeliverycharges;
               tempObj['Rate per Item within Child Shipment (INR)'] = el.openpickdeliveryrateperitem;
               tempObj['Minimum Cost per Docket'] = el.openpickdeliverychargesminimum;
               tempObj['Holiday Applicable'] = el.holidaydeliverychargeapplicable;
               tempObj['Holiday Delivery','Rate per kg per Docket'] = el.holidaydeliverychargesperkg;
               tempObj['Holiday Delivery Rate per Box per Docket'] = el.holidaydeliverychargesperbox;
               tempObj['Holiday Delivery Minimum Cost per Docket'] = el.holidaydeliverymincharges;
               tempObj['Billing Cycle'] = el.billingcycle;
               tempObj['POD Hard Copy Required'] = el.podhardcopyrequired;
               tempObj['POD Hard Copy Charges (INR per POD)'] = el.podhardcopycharges;
               tempObj['Credit Period (Days) - From date of Submission of Bill'] = el.creditperioddays;
               tempObj['Credit Limit'] = el.creditlimit;
               tempObj['Advance Payment %'] = el.ftladvancepayment;
               tempObj['Credit Limit Alert %'] = el.creditlimitalert;
               tempObj['Max Liability'] = el.maxliability;

              let tempArr = [];
         			if(el.paymentmode.includes("1")){
         				tempArr.push("Cheque");
         			}
         			if(el.paymentmode.includes("2")){
         				tempArr.push("Demand Draft");
         			}
         			if(el.paymentmode.includes("3")){
         				tempArr.push("RTGS");
         			}
         			let paymentmode = tempArr.join(", ");
              tempObj['Payment Mode'] = paymentmode;
               return tempObj;
             });
          const clientdata = XLSX.utils.json_to_sheet(tempData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, clientdata, 'ClientCommersialData')
          XLSX.writeFile(wb,'ClientCommercialDetails.xlsx');
        }else{
          this.$alert("No Client records to download", "Client Commercial Details", "error");
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getCompanyShortName(){
     try {
       let InputPayload = {};
       var CompanyShortList = [];
       this.isLoading = true;
       let result = await ClientService.GetClientListByActiveContracts(InputPayload)
       this.isLoading = false;
       CompanyShortList = result.data.data.rows;
       for (var i = 0; i < CompanyShortList.length; i++) {
         this.Clientlist.push({
           'id': CompanyShortList[i].clientid,
           'label': CompanyShortList[i].clientshortname +' ('+CompanyShortList[i].clientid+')',
           'ContractId': CompanyShortList[i].id,
           'CompanyName': CompanyShortList[i].clientcompanyname,
           'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid,
           'ClientBusinessDetailId' :  CompanyShortList[i].clientbusinessdetailid,
         })
       }
     } catch(err){
       console.log(err);
     }
   },
   selectClient(data){
     if(data){
       this.ClientID = data.id;
     }
   },
   async checkclientDetails() {
       if (this.client == null) {
         this.$alert("Please select Client", "", "error");
         return false;
       } else if(this.routeModeSearch == null){
         this.$alert("Please select Route Mode", "", "error");
         return false;
       }else{
         this.downloadClientLevelReport();
         return true;
       }
     }
  }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/clientLevelReport/clientLevelReport.component.js